// src/api/axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 10000,
});

// Interceptor para agregar el token a cada petición (simulamos un token guardado en localStorage)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // Se espera que se guarde el token tras el login
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
